import React from 'react';

import UserAvatar from '@bibliocommons/user-avatar';
import UserBadge from '@bibliocommons/user-badge';
import { accountShape, userIdentityShape } from '@bibliocommons/bc-prop-types';

import './UserAccountInfo.scss';

export default function UserAccountInfo({ currentAccount, currentUser }) {
  return (
    <div className="cp-user-account-info">
      <UserAvatar hideLink userIdentity={currentUser} />
      <div className="info">
        <div className="info-top">
          <span className="username">{currentUser.get('name', '')}</span>
          <UserBadge userIdentity={currentUser} />
        </div>
        {currentAccount?.get('barcode') && <span className="barcode">{currentAccount.get('barcode')}</span>}
      </div>
    </div>
  );
}

UserAccountInfo.propTypes = {
  currentAccount: accountShape,
  currentUser: userIdentityShape
};
